import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachDepartmentListsTranslation } from '../i18n';
import type { AttachDepartmentListsProps } from '../types';
import { AttachDepartmentListsDropdown } from './AttachDepartmentListsDropdown';

type AttachDepartmentListsButtonProps =
  AttachDepartmentListsProps &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachDepartmentListsButton';
const testid = buildTestid(displayName);

function AttachDepartmentListsButton({
  departmentId,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachDepartmentListsButtonProps): React.JSX.Element {
  const { t } = useAttachDepartmentListsTranslation();

  return (
    <AttachDepartmentListsDropdown
      departmentId={departmentId}
      disabled={disabled}
    >
      <Button
        icon={<PlusIcon />}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('title')}
      </Button>
    </AttachDepartmentListsDropdown>
  );
}

AttachDepartmentListsButton.displayName = displayName;

export { AttachDepartmentListsButton };
